module.exports = __webpack_public_path__ + "img/lang_icn.71d0652d.png";